import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemCollection, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** portfolio — project cards with optional images. */
export function renderPortfolio(section: PatternSectionT): string {
  const heading = str(section.fields, 'heading');
  const label = str(section.fields, 'label');
  const projects = list(section.fields, 'projects')
    .map((item, index) => {
      const title = itemStr(item, 'title');
      const description = itemStr(item, 'description');
      const imageUrl = itemStr(item, 'image_url');
      const alt = itemStr(item, 'alt') || itemStr(item, 'image_alt');
      if (!title && !description && !imageUrl) return '';
      const projectPath = `/projects/${index}`;
      const lines = [`    <article class="ve-portfolio__project"${editAttr(section, projectPath)}>`];
      if (imageUrl) {
        const imagePath = `/projects/${index}/image_url`;
        lines.push(`      <img class="ve-portfolio__image" src="${safeUrl(imageUrl)}" alt="${escapeHtml(alt)}"${editAttr(section, imagePath)}>`);
      }
      if (title) lines.push(`      <h3 class="ve-portfolio__title">${escapeHtml(title)}</h3>`);
      if (description) lines.push(`      <p class="ve-portfolio__description">${escapeHtml(description)}</p>`);
      lines.push('    </article>');
      return lines.join('\n');
    })
    .filter(Boolean)
    .join('\n');

  const parts: string[] = [
    sectionOpen(section),
    ...labeledIntro(section, 'portfolio', heading, label),
    itemCollection(section, 'div', 've-portfolio__projects', '/projects', projects),
    '</section>',
  ];
  return parts.join('\n');
}
